import PhaseItemModal from 'pages/project-dashboard/sections/schedule/modals/phase-item-modal';
import { useMemo } from 'react';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import { useGetProjectByIdQuery } from 'redux-store/api/projects';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { authSelector } from 'redux-store/selector';
import { weekDayNumbers } from 'utils/helpers';
import { calculateBusinessDays } from 'utils/postDateHelper';

export const PhaseItemHashtagModal = ({
  projectId,
  onClose,
}: {
  projectId: number;
  onClose: () => void;
}) => {
  const phaseItemId = useAppSelector((state) => state.hashtag.phaseItemId);
  const { companyId } = useAppSelector(authSelector);

  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery(undefined, {
    skip: !companyId,
  });

  const { data: project } = useGetProjectByIdQuery({ id: projectId! }, { skip: !projectId });

  const currentPhaseItem = useMemo(() => {
    if (!project?.phases?.length || !phaseItemId) return undefined;
    return project.phases
      .flatMap((phase) => phase.items || [])
      .find((item) => item.id === phaseItemId);
  }, [project, phaseItemId]);

  const { id, tz, phases, lagType } = project || {};

  if (!currentPhaseItem || !userPermissions.MANAGE_SCHEDULE.canRead) return null;

  const days = calculateBusinessDays(
    currentPhaseItem?.startDate,
    currentPhaseItem?.endDate,
    weekDayNumbers
  );

  return (
    <PhaseItemModal
      projectId={id}
      projectTz={tz}
      phases={phases}
      open
      currentPhaseItem={currentPhaseItem}
      lagType={lagType}
      closeModal={onClose}
      days={days}
    />
  );
};
